export default "__VITE_ASSET__80dda608__"